game = {};
gameData = {};
gameData.gameName = "Get Kraken";
gameData.version = "1.0.6";
gameData.gameReleaseDate = "16/06/2026";

gameData.symbolWidth = 168;
gameData.symbolHeight = 175;
gameData.appertureSize = 175;
gameData.numReels = 15;
game.timeScale = 1;
gameData.luckyBetUplift = 1.5;

gameData.themeTuneId = undefined;
gameData.freespinsThemeTuneId = undefined;
gameData.mainTunePlaying = false;
game.sideMenuOpen = false;

gameData.convertStringToSegmentId = function (str) {
  switch (str) {
    case "segmentGreen": {
      return gameData.segmentDollar;
    }
    case "segmentYellow": {
      return gameData.segmentBigWin;
    }
    case "segmentBlue": {
      return gameData.segmentBonus;
    }
    case "segmentRed": {
      return gameData.segmentFreespins;
    }
    case "fsSegmentMega": {
      return gameData.fsSegmentMega;
    }
    case "fsSegmentSuper": {
      return gameData.fsSegmentSuper;
    }
    case "fsSegmentMidi": {
      return gameData.fsSegmentMidi;
    }
    case "fsSegmentMinor": {
      return gameData.fsSegmentMinor;
    }
    case "fsSegmentMini": {
      return gameData.fsSegmentMini;
    }
    case "fsSegment3Fs": {
      return gameData.fsSegment3Fs;
    }
    case "fsSegment5Fs": {
      return gameData.fsSegment5Fs;
    }
    case "fsSegment8Fs": {
      return gameData.fsSegment8Fs;
    }
    default: {
      console.log("");
    }
  }
};

game.autoplayPopupOpen = false;

game.splashScreenDone = false;

Reflex.enableDeveloperMode();
//Reflex.developerModeData.createTestLanguages = true;
//Reflex.developerModeData.highlightTranslatedText = true;

game.onCreditChanged = function (creditTask) {
  gameData.credit = creditTask.data.balance;
  // gameData.creditMeter.set(creditTask.data.balance);
  let credit = creditTask.data.balance;
  if (
    gdk.serverParser._inReplayMode === true &&
    gdk.serverParser._endGame === true &&
    gdk.serverParser.prepaidResultBalance !== 0
  ) {
    credit = gdk.serverParser.prepaidResultBalance;
  }
  gameData.creditMeter.set(credit);
  // gameData.creditMeterMobile.set(credit);
};

function prepaidStakeChanged(stake) {
  gameData.stakeMeter.set(stake);
}

function promotionEnded() {
  const stakeController = resourceManager.getController("stakeController");
  const newStake = stakeController.getCurrentStake();
  gameData.stakeMeter.set(newStake);
}

game.onKeyDown = function (event) {
  if (!gdk.hasForceOptions()) {
    return;
  }

  if (event.key === "*") {
    game.timeScale *= 2;
  } else if (event.key === "/") {
    game.timeScale /= 2;
  } else if (event.key === "-") {
    game.timeScale = 1;
  } else if (event.key === "0") {
    game.timeScale = 0;
  } else if (event.key === "1") {
    game.timeScale = 0.0625;
  } else if (event.key === "2") {
    game.timeScale = 0.125;
  } else if (event.key === "3") {
    game.timeScale = 0.25;
  } else if (event.key === "4") {
    game.timeScale = 0.5;
  } else if (event.key === "5") {
    game.timeScale = 1;
  } else if (event.key === "6") {
    game.timeScale = 2;
  } else if (event.key === "7") {
    game.timeScale = 4;
  } else if (event.key === "8") {
    game.timeScale = 8;
  } else if (event.key === "9") {
    game.timeScale = 16;
  }

  if (game.timeScale > 256) game.timeScale = 256;
  if (game.timeScale < 0) game.timeScale = 0;

  game.setSpeed(game.timeScale);
};

game.setSpeed = function (speed) {
  if (Reflex.gamePaused || Reflex.platformPaused) {
    soundManager.pauseAllSounds();
  } else {
    soundManager.resumeAllSounds();
  }
  soundManager.setTimeScale(speed);
  gsap.globalTimeline.timeScale(speed);
  Reflex.setGameSpeed(speed);
};

game.createGameVersion = function () {
  var versionString = gameData.gameName + " v" + gameData.version;
  console.log(versionString);
};

game.initialise = function (gameConfigTask) {
  // --------------------------------------------------------------------------------------------
  // All game data has been loaded, initial layout has been set, and gameData has been populated.
  // Time to link everything together.
  // --------------------------------------------------------------------------------------------
  var i;

  // Create the game version text
  game.createGameVersion();

  gameData.gameConfig = gameConfigTask.data;

  // Set initial state
  resourceManager.getController("inputOverlord").setState("enabled");

  // Hide all screens except loading. These will be shown when loading continues
  resourceManager.getContainer("gameContainer").visible = false;
  resourceManager.getContainer("DemoContainer").visible = false;
  resourceManager.getContainer("gameButtonContainer").visible = false;

  gameData.stakes = [];
  gameData.coinSizes = [];
  gameData.currentStakeIndex = gameConfigTask.data.slotConfig.coinSizes.indexOf(
    gameConfigTask.data.slotConfig.defaultAmountPerLine
  );
  gameData.numLines = gameConfigTask.data.slotConfig.defaultNumLines;
  for (i = 0; i < gameConfigTask.data.slotConfig.coinSizes.length; i++) {
    gameData.stakes.push(gameConfigTask.data.slotConfig.coinSizes[i] * gameConfigTask.data.slotConfig.defaultNumLines);
    gameData.coinSizes.push(gameConfigTask.data.slotConfig.coinSizes[i]);
  }

  gameData.gameMathsVersion = gameConfigTask.data.mathsVersion;

  gameData.stakeMeter = resourceManager.get("meterContainer:stake:meter");
  gameData.creditMeter = resourceManager.get("meterContainer:credit:meter");
  gameData.winningsMeter = resourceManager.get("meterContainer:winnings:meter");
  gameData.winningsMeterTitle = resourceManager.get("meterContainer:winnings:title");

  game.changeStake(gameData.stakes[gameData.currentStakeIndex]);

  messageBus.subscribe("common:BalanceEvent", game.onCreditChanged);
  messageBus.subscribe("prepaid:StakeChange", prepaidStakeChanged);
  messageBus.subscribe("common:PromotionEnded", promotionEnded);
  messageBus.subscribe("game:modal", game.modal);
  messageBus.subscribe("game:sideMenuOpen", game.sideMenuOpenMsg);
  messageBus.subscribe("game:sideMenuClosed", game.sideMenuClosedMsg);
  Reflex.registerEventHandler("orientationChange", game.onOrientationChange);
  Reflex.registerEventHandler("resize", game.onResize);
  messageBus.subscribe("game:backFromReplay", game.backFromReplay);

  gameController.initialise(gameConfigTask);

  // Kick off the game
  game.onOrientationChange();
  gameController.start();
};

game.sideMenuOpenMsg = function () {
  game.sideMenuOpen = true;
};

game.sideMenuClosedMsg = function () {
  game.sideMenuOpen = false;
};

game.onResize = function () {
  if (gameData.gameMask) {
    if (systemData.isLandscape) {
      gameData.gameMask.scale.x = 1280;
      gameData.gameMask.scale.y = 720;
    } else {
      gameData.gameMask.scale.x = 720;
      gameData.gameMask.scale.y = 1280;
    }
  }
};

game.onOrientationChange = function () {
  if (game.slideShowActive) {
    game.updateSplashScreen();
  }
};

game.disableSplashBackgrounds = function (background, portrait_background) {
  background.visible = false;
  background.interactive = false;
  background.on("mouseup", function () {});
  background.on("touchend", function () {});
  portrait_background.visible = false;
  portrait_background.interactive = false;
  portrait_background.on("mouseup", function () {});
  portrait_background.on("touchend", function () {});
};

game.onCloseTutorial = function () {
  if (game.splashScreenDone) {
    return;
  }

  const bgContainer = resourceManager.getContainer("backgroundContainer");
  bgContainer.visible = true;
  gameData.gameMask = new PIXI.Graphics();
  gameData.gameMask.beginFill(0xffffff);
  gameData.gameMask.lineStyle(0, 0xffffff);
  gameData.gameMask.drawRect(0, 0, 1, 1);
  bgContainer.addChild(gameData.gameMask);

  if (gameData.license === "" || gameData.license === undefined) {
    gameData.license = "default";
  }
  let license = gameData.license.toUpperCase();

  if (license === "BR") {
    resourceManager.get("helpPageScrollContainer:helpPageScroll").open();
  }

  systemData.gameContainer.mask = gameData.gameMask;

  if (gameData.recoveryStake) {
    gameData.stakeMeter.set(gameData.recoveryStake);
  }

  game.goToGame();
};

game.goToSplash = function () {
  if (!gdk.getPlatformAllowsSplashScreen?.()) {
    if (gameData.license === "" || gameData.license === undefined) {
      gameData.license = "default";
    }

    let license = gameData.license.toUpperCase();

    gameController.slotMachine.update(0);

    if (license !== "BR") {
      gdk.loadingClosed();
    }
    Reflex.updateViewport();
  }
};

game.goToGame = function () {
  if (gdk.deviceInfo.chrome) {
    var chromeVersion = Number(
      String(gdk.deviceInfo.version).substring(0, String(gdk.deviceInfo.version).indexOf("."))
    );
    if (chromeVersion >= 55) {
      // Chrome will only start audio on a touch
      Howler.ctx.resume();
    }
  }

  musicManager.onGameLoaded();

  game.splashScreenDone = true;

  game.slideShowActive = false;

  timerManager.stop(game.slideshowTimer);

  gameData.mainTunePlaying = true;

  resourceManager.getContainer("loadingContainer").visible = false;
  resourceManager.getContainer("gameContainer").visible = true;
  resourceManager.getContainer("msgBoxPopupContainer").visible = true;
  resourceManager.getContainer("gameButtonContainer").visible = true;
  resourceManager.getContainer("particleContainer").visible = true;
  resourceManager.getContainer("buyABonusContainer").visible = true;
  resourceManager.getContainer("settingsMenuContainer").visible = true;
  resourceManager.getContainer("splashContainer").visible = false;
  resourceManager.getContainer("helpPageScrollContainer").visible = true;
  resourceManager.getContainer("bubblesContainer").visible = true;

  gameData.helpPageScroll = resourceManager.get("helpPageScrollContainer:helpPageScroll");
  gameData.winningsText = resourceManager.get("winningsText");
  game.loadingBackgroundLandscape = resourceManager.get("splashBackgroundL");
  game.loadingBackgroundLandscape.clearInteractiveCallbacks();
  game.loadingBackgroundPortrait = resourceManager.get("splashBackgroundP");
  game.loadingBackgroundPortrait.clearInteractiveCallbacks();

  resourceManager.getContainer("DemoContainer").visible = true;

  game.onResize();

  game.onOrientationChange();

  //game.overrideButtons();
  if (!Reflex.developerMode && gdk.deviceInfo.mobile && !gdk.isFullscreen()) {
    gdk.requestFullscreen();
  }

  if (gameController.inRecovery) {
    gameController.initNewGame(true);
  }

  gameController.setIdle(true);
};

game.overrideButtons = function () {
  game.addNonNumpadSpeedControl();

  const uiName = "uiContainer:bg";

  // const slamStopButton = resourceManager.get(uiName + ":slamStopButton");
  // slamStopButton.canEnableBase = slamStopButton.canEnable;
  // slamStopButton.canEnable = function(){
  //     return slamStopButton.canEnableBase() && !gameController.spinComplete && gameData.reelsSpinning > 0 && gameController.canSlamStop;
  // };
  // const slamStopButtonPortrait = resourceManager.get("buttonContainerMobile:reflexButtonBar:slamStopButton_portrait");
  // slamStopButtonPortrait.canEnableBase = slamStopButtonPortrait.canEnable;
  // slamStopButtonPortrait.canEnable = function(){
  //     return slamStopButtonPortrait.canEnableBase() && !gameController.spinComplete && gameData.reelsSpinning > 0 && gameController.canSlamStop;
  // };

  const autoplayController = resourceManager.getController("autoplayController");

  const baseStart = autoplayController.start;
  const baseCancel = autoplayController.cancel;

  autoplayController.start = function () {
    soundManager.play("buttonPressed");
    baseStart();
  };

  autoplayController.cancel = function () {
    if (game.autoplayPopupOpen) {
      soundManager.play("buttonPressed");
    }
    baseCancel();
  };

  const spinButton = resourceManager.get("uiContainer:bg:spinButton");
  spinButton.canEnableBase = spinButton.canEnable;
  spinButton.canEnable = function () {
    return (
      this.canEnableBase() &&
      /*!settingsMenu.container.visible &&*/ !helpPageManager.container.visible &&
      !game.sideMenuOpen
    );
  };
  const spinButtonPortrait = resourceManager.get("buttonContainerMobile:reflexButtonBar:spinButton_portrait");
  spinButtonPortrait.canEnableBase = spinButtonPortrait.canEnable;
  spinButtonPortrait.canEnable = function () {
    return (
      this.canEnableBase() &&
      /*!settingsMenu.container.visible &&*/ !helpPageManager.container.visible &&
      !game.sideMenuOpen
    );
  };

  const autoplayButton = resourceManager.get("uiContainer:bg:autoplayButton");
  autoplayButton.baseCanEnable = autoplayButton.canEnable;
  autoplayButton.canEnable = function () {
    return this.baseCanEnable() && !game.sideMenuOpen;
  };
  const autoplayButtonPortrait = resourceManager.get("buttonContainerMobile:reflexButtonBar:autoplayButton_portrait");
  autoplayButtonPortrait.baseCanEnable = autoplayButtonPortrait.canEnable;
  autoplayButtonPortrait.canEnable = function () {
    return this.baseCanEnable() && !game.sideMenuOpen;
  };

  const stakeButton = resourceManager.get("uiContainer:bg:stake");
  stakeButton.baseCanEnable = stakeButton.canEnable;
  stakeButton.canEnable = function () {
    return this.baseCanEnable() && !game.sideMenuOpen;
  };
  const stakeButtonPortrait = resourceManager.get("buttonContainerMobile:reflexButtonBar:stake_portrait");
  stakeButtonPortrait.baseCanEnable = stakeButtonPortrait.canEnable;
  stakeButtonPortrait.canEnable = function () {
    return this.baseCanEnable() && !game.sideMenuOpen;
  };

  const volumeButton = resourceManager.get("uiContainer:bg:volume");
  volumeButton.baseCanEnable = volumeButton.canEnable;
  volumeButton.canEnable = function () {
    return this.baseCanEnable() && !game.sideMenuOpen;
  };
};

game.modal = function (task) {
  if (task.reason === "autoplay") {
    game.autoplayPopupOpen = true;
  } else if (task.reason === undefined || task.reason === "") {
    game.autoplayPopupOpen = false;
  }
};

game.addNonNumpadSpeedControl = function () {
  if (gdk.isDevelopmentBuild()) {
    Reflex.developerModeData.keyDownCallbacks.push(function (keycode) {
      if (!Reflex.developerModeData.manipulateCredit) {
        switch (keycode) {
          case 32: {
            // Pause/break key
            Reflex.gamePaused = !Reflex.gamePaused;
            break;
          }
          case 48: {
            // Keypad 0
            Reflex.gamePaused = !Reflex.gamePaused;
            break;
          }
          case 49: {
            // Keypad 1
            Reflex.developerModeData.speedModifier = 0.0625;
            break;
          }
          case 50: {
            // Keypad 2
            Reflex.developerModeData.speedModifier = 0.125;
            break;
          }
          case 51: {
            // Keypad 3
            Reflex.developerModeData.speedModifier = 0.25;
            break;
          }
          case 52: {
            // Keypad 4
            Reflex.developerModeData.speedModifier = 0.5;
            break;
          }
          case 53: {
            // Keypad 5
            Reflex.developerModeData.speedModifier = 1.0;
            break;
          }
          case 54: {
            // Keypad 6
            Reflex.developerModeData.speedModifier = 2.0;
            break;
          }
          case 55: {
            // Keypad 7
            Reflex.developerModeData.speedModifier = 4.0;
            break;
          }
          case 56: {
            // Keypad 8
            Reflex.developerModeData.speedModifier = 8.0;
            break;
          }
          case 57: {
            // Keypad 9
            Reflex.developerModeData.speedModifier = 16.0;
            break;
          }
          case 58: {
            // * key
            Reflex.developerModeData.speedModifier += 0.05;
            break;
          }
          case 59: {
            // / Key
            Reflex.developerModeData.speedModifier -= 0.05;
            break;
          }
          default:
            break;
        }

        if (Reflex.developerModeData.speedModifier > 256) Reflex.developerModeData.speedModifier = 256;
        if (Reflex.developerModeData.speedModifier < 0.00390625) Reflex.developerModeData.speedModifier = 0.00390625;

        if (Reflex.gamePaused || Reflex.platformPaused) {
          soundManager.pauseAllSounds();
        } else {
          soundManager.resumeAllSounds();
        }
        soundManager.setTimeScale(Reflex.developerModeData.speedModifier);
        PIXI.ticker.shared.speed = Reflex.developerModeData.speedModifier;
      }
    });
  }
};

game.changeStake = function (stake) {
  gameData.stakeMeter.set(stake);
  gdk.playerChangedStake(stake);
};

game.onHelpPagesClosed = function () {};

game.onOptionsButtonPressed = function () {
  helpPageManager.showPopup(game.onHelpPagesClosed);
};

game.onAutoplayDialogCancelled = function () {};

game.onAutoplayDialogConfirmed = function () {
  gameController.startAutoplay();
};

game.onAutoplayButtonPressed = function () {
  // If autoplay is running, cancel
  if (autoplayManager.isAutoplayEnabled()) {
    if (gameController.state === "WAITING_FOR_AUTOPLAY") {
      soundManager.play("buttonPressed");
    } else {
      // We are autoplaying, so wait for autoplay to complete before enabling buttons
      gameData.autoplayButton.enableButton(false);
    }

    autoplayManager.stopAutoplay();
    gameController.cancelAutoplay();

    return;
  }

  // If we are in a waiting state, pop up the auto play interface
  if (gameController.state === "WAITING_FOR_START") {
    soundManager.play(gameData.sounds.autoplayPress);
    autoplayManager.openDialog(
      game.onAutoplayDialogConfirmed,
      game.onAutoplayDialogCancelled,
      gameData.coinSizes[gameData.currentStakeIndex],
      10
    );
  }
};

game.backFromReplay = function (data) {
  if (
    soundManager.sharedMode === true // we have been sharing the soundManager
  ) {
    // im going to assume the back button has been pressed during watching a replay
    // the ygg platform is telling us to unmute audio
    // stop any sounds currently playing from the old replay game
    // then clear the sharedMode flag
    // we need to restore what audio and what levels they were playing at
    // this will be down to each client to handle this as ids are stored all over the place
    // the music managers are inconsistant
    soundManager.stopAllSounds();
    soundManager.sharedMode = false;
    messageBus.post("sounds:restorePreviouslyPlayingAudio", {
      reason: "back from replay",
    });
  }
};
